import { headers } from './requestConfig';
import { teamGetSets, teamUpdateSets, teamApplySet } from '../service/links';
import { trackSetTeam } from '../service/analytics';

export const fetchTeamSets = async () =>
  fetch(teamGetSets, {
    method: 'GET',
    headers,
    credentials: 'include',
  });

export const saveTeamSets = async (sets) =>
  fetch(teamUpdateSets, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ sets }),
  });

/**
 * Apply a saved preset (POST /team/applySet). On a 200 this is a formation
 * save, so it fires Mixpanel `set_team` like mobile. It does not go through
 * POST /team/strategy, so set_team is never double-fired. `formation` is the
 * preset's formation index, passed by the caller (optional, as on mobile).
 */
export const applyTeamSet = async (name, formation) => {
  const response = await fetch(teamApplySet, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ name }),
  });
  if (response && response.status === 200) trackSetTeam({ formation });
  return response;
};
